import { pdfjs } from "react-pdf";

/**
 * Centralized PDF.js worker configuration
 * This ensures we only configure the worker once and prevent multiple instances
 */
let isWorkerConfigured = false;

export function configurePdfWorker(): void {
	if (isWorkerConfigured) {
		return;
	}

	// Configure PDF.js worker
	pdfjs.GlobalWorkerOptions.workerSrc = new URL(
		"pdfjs-dist/build/pdf.worker.min.js",
		import.meta.url
	).toString();

	isWorkerConfigured = true;
}

// Configure worker immediately when this module is imported
configurePdfWorker();